
import Modal from "react-bootstrap/Modal";
import userimg from "../../assets/images/user.png";
import searchicon from "../../assets/images/search-icon.svg";
import { folderService } from "services";
import { useEffect, useMemo, useState } from "react";
import useCurrentUser from "hooks/useCurrentUser";
import { toast } from "react-toastify";
import usePilotClients from "hooks/usePilotClients";

function ShareFolder(props) {
  const { show, handleClose, folderId } = props;
  const { pilotClientsData } = usePilotClients(show);
  const { user } = useCurrentUser();

  const [query, setQuery] = useState("");

  const filteredItems = useMemo(() => {
    return pilotClientsData?.length > 0 && pilotClientsData.filter(item => {
      return item?.client?.fullName?.toLowerCase()?.includes(query?.toLowerCase())
    })
  }, [pilotClientsData, query])

  const handleQryChange = (e) => {
    setQuery(e.target.value);
  }

  const handleShare = async (id) => {
    const payload = {
      "folderId": folderId,
      "clientId": id
    }
    const response = await folderService.shareList(payload)
    toast.success(response?.data?.message)
  }

  return (
    <>
      <Modal show={show} className="modal-common share-folder" onHide={() => {
        handleClose();
        setQuery('');
      }}

      >
        <Modal.Header closeButton>Share</Modal.Header>
        <Modal.Body >
          <div className="search-bar mb-4">
            <div className="search-container">
              <input
                type="text"
                placeholder="Search"
                className="form-control"
                onChange={handleQryChange}
              />
              <div className="search-button">
                <img src={searchicon} alt="" />
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-between py-2 align-items-center flex-column">
            {filteredItems?.length > 0 ? filteredItems?.map((item, i) => {
              return <>
                <div className="d-flex align-items-center justify-content-between w-100 share-div gap-2">
                  <div className="d-flex align-items-center gap-3">
                    <img
                      src={`${user?.baseS3Url}${item?.client?.avatar || ""}`}
                      alt="Client Avatar"
                      className="round-img"
                      onError={(e) => {
                        e.currentTarget.onerror = null; // prevent infinite loop
                        e.currentTarget.src = userimg;  // fallback avatar
                      }}
                    />

                    <p className="mb-0 dark-textss">{item?.client?.fullName}</p>
                  </div>
                  <div className="form-check" onClick={() => handleShare(item?._id)}>
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      defaultValue
                      id="flexCheckDefault"
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckDefault"
                    >
                    </label>
                  </div>
                </div>
              </>
            }) : <h5 className="my-5 text-blue">No search data </h5>}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ShareFolder;
